module.exports = __webpack_public_path__ + "img/Burger_menu.758a7a82.svg";